var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_group",
    "data-name": "vuesax/linear/group",
    transform: "translate(-748 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(748 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.513,9.5H8.3A1.588,1.588,0,0,0,9.888,7.917V0H2.763A3.164,3.164,0,0,0,0,1.623",
    transform: "translate(1.987 1.583)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,9.5a2.372,2.372,0,0,0,2.375,2.375h.792a1.583,1.583,0,0,1,3.167,0H9.5a1.583,1.583,0,0,1,3.167,0h.792A2.372,2.372,0,0,0,15.833,9.5V7.125H13.458a.794.794,0,0,1-.792-.792V3.958a.794.794,0,0,1,.792-.792H14.48L13.126.8A1.6,1.6,0,0,0,11.748,0H10.292V5.542A1.588,1.588,0,0,1,8.708,7.125H7.917",
    transform: "translate(1.583 3.958)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M3.167,1.583A1.583,1.583,0,1,1,1.583,0,1.583,1.583,0,0,1,3.167,1.583Z",
    transform: "translate(4.75 14.25)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M3.167,1.583A1.583,1.583,0,1,1,1.583,0,1.583,1.583,0,0,1,3.167,1.583Z",
    transform: "translate(11.083 14.25)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M3.167,2.375V3.958H.792A.794.794,0,0,1,0,3.167V.792A.794.794,0,0,1,.792,0H1.813Z",
    transform: "translate(14.25 7.125)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H4.75",
    transform: "translate(1.583 6.333)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M0,0H3.167",
    transform: "translate(1.583 8.708)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M0,0H1.583",
    transform: "translate(1.583 11.083)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-9",
    "data-name": "Vector",
    d: "M0,0H19V19H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogistics);
export default __webpack_public_path__ + "static/media/logistics.3b3e4b0b001790caff6b4a2ec91ea671.svg";
export { ForwardRef as ReactComponent };